import { Button, ButtonProps } from "@eworkit/iris";
import React, { FC, useCallback } from "react";
import { useDialogState } from "reakit/Dialog";

import { ConsultantProfile } from "@/data/consultant-profiles/types/ConsultantProfile";
import AddNewProfileDialog from "@/views/Invitations/AddNewProfileDialog";

interface IInviteUserButtonProps extends Omit<ButtonProps, "onClick"> {
  onSuccess?: (profile: ConsultantProfile) => void;
}

export const InviteUserButton: FC<IInviteUserButtonProps> = ({ onSuccess, ...buttonProps }) => {
  const addNewProfileDialogState = useDialogState({ animated: true });

  const handleClick = useCallback(() => {
    addNewProfileDialogState.show();
  }, [addNewProfileDialogState]);

  return (
    <>
      <Button onClick={handleClick} {...buttonProps} />

      <AddNewProfileDialog dialogState={addNewProfileDialogState} onSuccess={onSuccess} />
    </>
  );
};
